import React, { type ReactNode, type FC, type PropsWithChildren } from 'react';

import styled from '@emotion/styled';
import { space, layout, variant, type SpaceProps, type LayoutProps, compose } from '@lucid/theme';

export type PaperVariants = 'default' | 'raised' | 'raisedLow';

export interface PaperProps extends SpaceProps, LayoutProps {
  /** Controls the HTML tag created for the Paper component. */
  as?: 'div' | 'section' | 'article';
  /** The children of the Paper component. */
  children: ReactNode;
  /** Allows the component to get additional styles. */
  className?: string;
  /** The available variants for the Paper component. */
  variant?: PaperVariants;
}

const paperStyles = compose(space, layout);

const PaperContainer = styled.div<PaperProps>(
  {
    display: 'block',
    textAlign: 'left',
  },
  variant({
    scale: 'paper',
    variants: {
      defaultVariant: {},
    },
  }),
  paperStyles,
);

const Paper: FC<PropsWithChildren<PaperProps>> = ({ children, className, variant = 'default', ...rest }) => (
  <PaperContainer {...rest} className={className} variant={variant}>
    {children}
  </PaperContainer>
);

export { Paper };
export default Paper;
